// extracted by mini-css-extract-plugin
module.exports = {"container":"use-agent-skills-anywhere_container__3iG0n","content":"use-agent-skills-anywhere_content__kPykd"};